import {Col, Hooks, HRInsider, Row} from '@microfrontends/react-components'
import { useContext } from 'react'
import { Container } from './styles'

import { ELanguage } from '@microfrontends/app-shell-v2'
import RecommendJobs from '../../../containers/NumerologyContainerV2/components/RecommendJobs'
import AppContext from '../../../context/AppContext'
import Banner from './Banner'
import BottomSection from './BottomSection'
import IndustryCareerPath from './IndustryCareerPath'
import IntroductionSection from './IntroductionSection'
import { ICareerPathByIndustry, TResponse } from './types'
import Article from "../../../components/CareerPath/Landing/components/Article";
import {IFamousPeople} from "../../../services/numerology/@type";
import {IArticle} from "../../../services/hrInsider";

const CAREER_PATH_BY_INDUSTRY_SERVICE_URL =
	process.env.API_DOMAIN + '/numerology/v1.0/career-path-by-industry'
const IMAGE_SERVICE = process.env.IMAGE_BASE_URL + '/images/career-path'
const UTM = {
	utm_source: 'career-path',
	utm_medium: 'job-will-love',
	utm_campaign: 'home'
}
const NUMEROLOGY_UTM = {
	utm_source_navi: 'bannerwebsite',
	utm_medium_navi: 'traffic',
	utm_campaign_navi: 'NSH2023',
	utm_term_navi: 'new-homepage'
}

interface ICareerPathLandingPageProps{
	careerPaths : ICareerPathByIndustry[]
	isRobot: boolean
	articles: IArticle[]
}

const CareerPathLandingPage = (props : ICareerPathLandingPageProps) => {
	const { isRobot = false, articles } = props
	const { languageCode = ELanguage.VI } = useContext(AppContext)
	const path = languageCode === ELanguage.VI ? '/nhan-so-hoc' : '/numerology'
	const href = process.env.VNW_BASE_URL + path + '?' + new URLSearchParams(NUMEROLOGY_UTM).toString()
	/*
	 * Fetching data
	 * */
	const { data } = Hooks.useFetch<TResponse<ICareerPathByIndustry[]>>(
		CAREER_PATH_BY_INDUSTRY_SERVICE_URL
	)
	return (
		<Container>
			<Col>
				<Banner careerPathByIndustryData={data?.data} />
			</Col>
			<Col>
				<IntroductionSection />
			</Col>
			<Col>
				<IndustryCareerPath careerPathByIndustryData={props.careerPaths} />
			</Col>
			<Col>
				<Article isRobot={isRobot} ssrArticles={articles} />
			</Col>
			<Col>
				<RecommendJobs title='VIỆC LÀM TỐT NHẤT' utm={UTM} />
			</Col>

			<Col>
				<BottomSection
					redirectLink={href}
					backGroundPath={`${IMAGE_SERVICE}/bottom-section-background.png`}
					bannerPath={`${IMAGE_SERVICE}/bottom-section-image.png`}
				/>
			</Col>
		</Container>
	)
}

export default CareerPathLandingPage
